import { MutationTree } from 'vuex'
import * as types from './types'
import { FlowFile } from '@appbase/libs/flowjs'

export default <MutationTree<file.state.FileState>>{
	[types.FILE_LIST](state, files: FlowFile[]) {
		state.files = files
	},

	[types.FILE_SELECT](state, options: file.FileSelectionOptions) {
		const select = options.select
		const ids = options.ids
		const files = state.files
		ids.forEach((id) => {
			const found = files.find((x) => x.uniqueIdentifier === id)
			if (found) {
				found.selected = select
			}
		})
	},

	[types.FILE_SELECT_ALL_TOGGLE](state) {
		const files = state.files
		const total = files.length
		if (total > 0) {
			if (files.filter((x) => x.selected).length === total) {
				files.forEach((x) => (x.selected = false))
			} else {
				files.forEach((x) => (x.selected = true))
			}
		}
	},

	[types.FILE_DELETE](state) {
		const files = state.files
		const deletes = files
			.filter((x) => x.selected)
			.map((x) => x.uniqueIdentifier)
		deletes.forEach((id) => {
			const idx = files.findIndex((x) => x.uniqueIdentifier === id)
			const file = files[idx]
			// Cancel current upload and remove from a list
			// file.cancel()
			file.flowObj.removeFile(file)
		})
	},
}
